module.exports = __webpack_public_path__ + "img/data_ingestion_active.b1b66aac.svg";